export default () => {
    var date = new Date();
    var timestamp = date.getTime();

    return timestamp;
}